import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/ar-images/icon/cbys-icon2.png'
import _imports_1 from '@/assets/images/ar-images/icon/cjys-icon2.png'
import _imports_2 from '@/assets/images/ar-images/icon/yycj-vps1.png'
import _imports_3 from '@/assets/images/ar-images/icon/yycj-vps2.png'
import _imports_4 from '@/assets/images/ar-images/icon/yycj-vps3.png'
import _imports_5 from '@/assets/images/ar-images/icon/yycj-vps4.png'


const _hoisted_1 = { class: "header-video" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "role-wrap" }
const _hoisted_4 = { class: "role-scene" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "yycj" }
const _hoisted_8 = { class: "scene-list-box" }
const _hoisted_9 = { class: "type-list" }
const _hoisted_10 = { class: "sljs" }
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "package" }
const _hoisted_14 = { class: "package-list" }
const _hoisted_15 = { class: "img-div" }
const _hoisted_16 = { class: "img-div" }

import { ref, reactive, onMounted, watch, onUnmounted } from 'vue';
import { asynchronousRetrieval } from '@/utils';
import router from '@/router';
import { modelTypes } from '@/config';

const MODEL = 'vision_ar_vps'

export default /*@__PURE__*/_defineComponent({
  __name: 'VPSView',
  setup(__props) {

const sceneTypeList = ['工业设计', '教育培训', '文博场馆', '城市规划', '停车场', '景区公园', '体育赛事', '商业街区', '历史遗迹', '演唱会', '科技馆', '旅游导览', '活动晚会', '娱乐体验', '大型会展', '智慧工厂']
const loadUrl: any = ref({})

onMounted(async () => {
  const studio_banner: any = await asynchronousRetrieval('webimg/images/vps-img.png');
  const qyzt: any = await asynchronousRetrieval('webimg/gif/qyzt.gif');
  const scdkj: any = await asynchronousRetrieval('webimg/gif/scdkj.gif');
  loadUrl.value = { studio_banner, qyzt, scdkj }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: loadUrl.value.studio_banner
      }, null, 8, _hoisted_2),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "video-text" }, [
        _createElementVNode("div", { class: "logo-text" }, [
          _createElementVNode("span", null, "混空"),
          _createElementVNode("span", null, "VPS")
        ]),
        _createElementVNode("div", { class: "link-room" }, "混空VPS（Visual Positioning System）由公司自主研发，是一款融合多源数据和AI视觉算法，提供高精度定位和环境感知，帮助开发者快速部署XR沉浸式体验的定位系统。")
      ], -1))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "title" }, [
        _createTextVNode("为您构建室内外稳定的"),
        _createElementVNode("span", { style: {"color":"#822EFF"} }, "空间计算能力")
      ], -1)),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(modelTypes)[MODEL], (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "item",
              key: item.header
            }, [
              _createElementVNode("img", {
                src: item.image,
                alt: ""
              }, null, 8, _hoisted_5),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("h3", null, _toDisplayString(item.header), 1),
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.remarkList, (remark) => {
                    return (_openBlock(), _createElementBlock("li", { key: remark }, _toDisplayString(remark), 1))
                  }), 128))
                ])
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _cache[19] || (_cache[19] = _createStaticVNode("<div class=\"wmdys\" data-v-5cb6848a><div class=\"title\" data-v-5cb6848a>我们的优势</div><div class=\"wmdys-content\" data-v-5cb6848a><div class=\"left\" data-v-5cb6848a><header data-v-5cb6848a><img src=\"" + _imports_0 + "\" class=\"l-iamge\" alt=\"\" data-v-5cb6848a><div class=\"r-head\" data-v-5cb6848a>成本优势</div></header><div class=\"line\" data-v-5cb6848a>· 技术使用成本低；</div><div class=\"line\" data-v-5cb6848a>· 云SAAS化服务降低使用门槛。</div></div><div class=\"right\" style=\"padding-right:19rem;box-sizing:border-box;\" data-v-5cb6848a><header data-v-5cb6848a><img src=\"" + _imports_1 + "\" class=\"l-iamge\" alt=\"\" data-v-5cb6848a><div class=\"r-head\" data-v-5cb6848a>场景优势</div></header><div class=\"line\" data-v-5cb6848a>· 现实空间三维建图、复杂环境感知、视觉导航上优势显著；</div><div class=\"line\" data-v-5cb6848a>· 在城市级别大空间和复杂环境定位上优势显著，如商业广场、博物馆、历史遗迹等；</div><div class=\"line\" data-v-5cb6848a>· 在机器人、自动驾驶、医疗、消费电子等领域具备可拓展前景。</div></div></div></div>", 1)),
    _createElementVNode("div", _hoisted_7, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "title deep" }, "应用场景", -1)),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sceneTypeList, (item) => {
            return _createElementVNode("div", { key: item }, _toDisplayString(item), 1)
          }), 64))
        ]),
        _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"scene-list\" data-v-5cb6848a><img src=\"" + _imports_2 + "\" data-v-5cb6848a><img src=\"" + _imports_3 + "\" data-v-5cb6848a><img src=\"" + _imports_4 + "\" data-v-5cb6848a><img src=\"" + _imports_5 + "\" data-v-5cb6848a></div>", 1))
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "title" }, "实例介绍", -1)),
      _createElementVNode("img", {
        src: loadUrl.value.qyzt
      }, null, 8, _hoisted_11),
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "title-sub" }, "企业展厅空间采集演示", -1)),
      _createElementVNode("img", {
        src: loadUrl.value.scdkj
      }, null, 8, _hoisted_12),
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "title-sub" }, "商场大空间采集演示", -1))
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", null, [
        _cache[17] || (_cache[17] = _createElementVNode("div", { class: "title deep" }, "按需选择 灵活购买", -1)),
        _cache[18] || (_cache[18] = _createElementVNode("div", { class: "title-tips deep" }, "混空VPS产品体系", -1)),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_15, [
              _cache[9] || (_cache[9] = _createElementVNode("div", null, "有并发要求", -1)),
              _cache[10] || (_cache[10] = _createElementVNode("div", { class: "suv-title2" }, "标准服务包含", -1)),
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "service-content" }, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", null, "定位面积"),
                  _createElementVNode("span", null, "定位服务时长"),
                  _createElementVNode("span", null, "并发数量"),
                  _createElementVNode("span", null, "技术支持")
                ])
              ], -1)),
              _cache[12] || (_cache[12] = _createElementVNode("div", { class: "contact-tips" }, "可根据您的项目实际情况，购买标准服务(支持按需扩展单项)", -1)),
              _createElementVNode("div", {
                class: "contact-btn",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/counselling')))
              }, "立即咨询")
            ]),
            _createElementVNode("div", _hoisted_16, [
              _cache[13] || (_cache[13] = _createElementVNode("div", null, "无并发要求", -1)),
              _cache[14] || (_cache[14] = _createElementVNode("div", { class: "suv-title2" }, "标准服务包含", -1)),
              _cache[15] || (_cache[15] = _createElementVNode("div", { class: "service-content" }, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", null, "定位面积"),
                  _createElementVNode("span", null, "定位服务时长"),
                  _createElementVNode("span", null, "技术支持")
                ])
              ], -1)),
              _cache[16] || (_cache[16] = _createElementVNode("div", { class: "contact-tips" }, "可根据您的项目实际情况，购买标准服务(支持按需扩展单项)", -1)),
              _createElementVNode("div", {
                class: "contact-btn",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push('/counselling')))
              }, "立即咨询")
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})